import { PublicClientApplication } from "@azure/msal-browser";

import { msalcfg } from "./authConfig";
import { getIsCypressAut } from "./helpers/isCypressAut";
import { rewriteMsalPathStyleOAuthHash } from "./helpers/msalPathStyleHash";

// Before PCA construction / redirect handling: undo HashRouter path-style OAuth hashes.
rewriteMsalPathStyleOAuthHash();

const msalInstance = new PublicClientApplication(msalcfg);
// Kick off initialization once and share the promise with all consumers
export const msalReady = msalInstance.initialize();
// Expose for Cypress so tests can introspect and seed cache via loadExternalTokens
if (typeof window !== "undefined" && getIsCypressAut()) {
  window.msalInstance = msalInstance;
}
export default msalInstance;
